import { useAccountList } from '@ltvco/refresh-lib/hooks';
import { Button, Grid, Text, styled } from '@ltvco/refresh-lib/theme';
import { enqueueSnackbar } from '@ltvco/refresh-lib/v1';
import { useState } from 'react';

interface DeleteListConfirmationProps {
  setAnchorEl: () => void;
  listCode: string;
}

const DeleteButton = styled(Button)`
  flex: 0 0 auto;
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;

export const DeleteListConfirmation = ({
  setAnchorEl,
  listCode,
}: DeleteListConfirmationProps) => {
  const [loadingState, setLoadingState] = useState(false);
  const { deleteList } = useAccountList();

  const handleDeleteClick = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    setLoadingState(true);
    deleteList.mutate(listCode, {
      onSuccess: () => {
        enqueueSnackbar('List deleted successfully', { variant: 'success' });
        setAnchorEl();
      },
      onError: () => {
        enqueueSnackbar('Failed to delete list', { variant: 'error' });
        setLoadingState(false);
      },
    });
  };

  const handleCancelClick = () => {
    setAnchorEl();
  };

  return (
    <Grid
      container
      spacing={2}
      width="287px"
      padding="20px"
      onClick={(event) => event.stopPropagation()}
    >
      <Grid size={12}>
        <Text variant="subtitle1" color="primary" aria-label="delete-header">
          Delete list
        </Text>
      </Grid>
      <Grid size={12}>
        <Text variant="body2">
          Are you sure you would like to delete this list? The list will be
          removed, but the reports will still be accessible via search or recent
          reports.
        </Text>
      </Grid>
      <Grid size={12}>
        <Button
          variant="contained"
          aria-label="delete-action"
          fullWidth
          onClick={handleDeleteClick}
          disabled={loadingState}
        >
          Delete list
        </Button>
      </Grid>
      <Grid size={12}>
        <DeleteButton fullWidth onClick={handleCancelClick}>
          Cancel
        </DeleteButton>
      </Grid>
    </Grid>
  );
};
